export enum PessoaTipoRelacionamento {
  ASSISTENCIA_LEGAL_ASCENDENTE = <any>  'ASSISTENCIA_LEGAL_ASCENDENTE',
  CURADOR = <any>  'CURADOR',
  OUTRO = <any>  'OUTRO',
  REPRESENTACAO_LEGAL_ASCENDENTE = <any>  'REPRESENTACAO_LEGAL_ASCENDENTE',
  REPRESENTADO = <any>  'REPRESENTADO',
  REPRESENTANTE = <any>  'REPRESENTANTE',
  SUBSTITUICAO_REPRESENTACAO_PROCESSUAL = <any>  'SUBSTITUICAO_REPRESENTACAO_PROCESSUAL',
  SUCESSOR = <any>  'SUCESSOR',
  TUTOR = <any>  'TUTOR',
  VINCULO = <any>  'VINCULO',
}
